import { optionsSelect } from '@components/application/DialogCancelJourney/Form/FieldRadios/FieldRadiosConstants';

export const translateReason = (slug: string): string => {
  const reason = optionsSelect.data.find((option) => option.slug === slug);

  return reason ? reason.text : slug;
};
